import { BarriersChart } from '@/pages/funds/ic-report/components/primitives/charts/BarriersChart'
import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { beta } from '@/react-query/queries/ic-report/hooks'

export interface CapitalGrowthChartProps extends ICReportChartPrimitive {}

export const CapitalGrowthChart: React.FC<CapitalGrowthChartProps> = ({ params }) => {
  const query = beta.useCapitalGrowthBarriers(params)
  const data = query.data ?? []

  return <BarriersChart data={data} dataHandle={'barrier_level'} params={params} />
}
